document.addEventListener('DOMContentLoaded', function () {
  const emblaNode = document.querySelector('.embla__viewport');
  const slideNodes = document.querySelectorAll('.embla__slide');

  const embla = EmblaCarousel(emblaNode, {
    loop: true,
    align: 'center',
    containScroll: false,
    skipSnaps: true,
  });

  // Scroll buttons
  document.querySelector('.embla__prev').addEventListener('click', () => embla.scrollPrev());
  document.querySelector('.embla__next').addEventListener('click', () => embla.scrollNext());

  slideNodes.forEach((slide, index) => {
    slide.addEventListener('click', () => {
      embla.scrollTo(index);
    });
  });

  // Plays active video and show mute control, pause the rest
  const updateActive = () => {
    const index = embla.selectedScrollSnap();

    slideNodes.forEach((slide, i) => {
      const video = slide.querySelector('.embla__slide__video video');
      const vid_ratio = slide.querySelector('.embla__slide__video');
      const unmuteBtn = slide.querySelector('.unmute-btn');
      const muteBtn = slide.querySelector('.mute-btn');

      if (i === index) {
        slide.setAttribute('data-active', '');
        if (unmuteBtn) unmuteBtn.style.display = 'flex';
        if (muteBtn) muteBtn.style.display = 'none';
      } else {
        slide.removeAttribute('data-active');
        if (unmuteBtn) unmuteBtn.style.display = 'none';
        if (muteBtn) muteBtn.style.display = 'none';
      }

      if (video && i === index) {
        video.play().catch((e) => console.warn('Autoplay prevented', e));
      } else {
        video.pause();
        // video.currentTime = 0;
      }
    });
  };

  // Mute / Unmute buttons
  slideNodes.forEach((slide) => {
    const video = slide.querySelector('.embla__slide__video video');
    const unmuteBtn = slide.querySelector('.unmute-btn');
    const muteBtn = slide.querySelector('.mute-btn');

    if (!video || !unmuteBtn || !muteBtn) return;

    unmuteBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      video.muted = false;
      unmuteBtn.style.display = 'none';
      muteBtn.style.display = 'flex';
      slide.setAttribute('data-muted', '');
    });

    muteBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      video.muted = true;
      muteBtn.style.display = 'none';
      unmuteBtn.style.display = 'flex';
      slide.removeAttribute('data-muted');
    });
  });

  embla.on('select', updateActive);
  embla.on('init', updateActive);

  updateActive();
});

// Quick add cart button
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.quick-buy-btn');
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  const variantId = btn.dataset.variantId;

  console.log('Variant:', variantId);

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1,
    }),
  })
    .then((res) => res.json())
    .then((data) => {
      console.log('Added to cart:', data);
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    })
    .catch((err) => console.error(err));
});
